import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface CompanyNameFormFieldProps {}

export const CompanyNameFormField: React.FC<CompanyNameFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ company_name: string }>()
  return (
    <FormField
      name="company_name"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Company Name</FormLabel>
              <FormError />
            </div>
            <Input {...register('company_name')} placeholder={'Enter an company name'} />
          </FormItem>
        )
      }}
    />
  )
}
